<div class="section-list card">


    <div *ngIf="!ismodal" class="card-header">
        <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header">
            <span class="navbar-brand mb-0 h1"><i class="fas fa-list"></i> Issues</span>
            <span class="badge badge-danger badge-err" matTooltip="Issues found">{{getIssueCount()}}</span>
            <ng-container *ngIf="uiShowFieldWhenOpen()">
                <span class="badge badge-success badge-err" *ngIf="uiStatusOpen">Checked: {{issuecheckedcount}}</span>
                <span class="badge badge-secondary badge-err" *ngIf="issueErrorCountToValidate>0">UnChecked:
                    {{issueErrorCountToValidate}}</span>
            </ng-container>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <div class="ml-auto d-flex justify-content-end">
                    <ul class="nav navbar-nav ml-auto">
                        <!--                         <li class="nav-item">
                            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="playissues()"
                                matTooltip="Play/Stop animation of issues"><i class="{{playIssues_class}}"></i></button>
                        </li> -->
                        <li class="nav-item dropdown" dropdown placement="bottom right" *ngIf="hasOMAccess">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
                                <i class="fas fa-tools mr-1"></i> O&M
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu
                                aria-labelledby="simple-dropdown1">
                                <!-- <div class="dropdown-header"><i class="fas fa-tools mr-1"></i>O&M</div> -->
                                <a *ngIf="hasOMAccess" class="dropdown-item" (click)="showOM=!showOM">
                                    <app-check-box-icon [checked]="showOM"></app-check-box-icon> Show O&M
                                </a>
                                <a *ngIf="hasOMAccess" class="dropdown-item" (click)="omMarkForReview()">
                                    Mark filtered issues({{issuecount}}) for reviewing
                                </a>                                
                            </div>
                        </li>
                        <li class="nav-item dropdown" dropdown placement="bottom right">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
                                aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
                                <i class="fas fa-ellipsis-v"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu
                                aria-labelledby="simple-dropdown1">

<!--                                 <a class="dropdown-item" (click)="showPanelType=!showPanelType">
                                    <app-check-box-icon [checked]="showPanelType"></app-check-box-icon> Show Panel Type
                                </a> -->
                                <a class="dropdown-item" (click)="showimageDate=!showimageDate">
                                    <app-check-box-icon [checked]="showimageDate"></app-check-box-icon> Show image date
                                </a>                                
<!--                                 <a class="dropdown-item" (click)="showTempMeasuresMin=!showTempMeasuresMin">
                                    <app-check-box-icon [checked]="showTempMeasuresMin"></app-check-box-icon> Show Min
                                    temperature
                                </a> -->
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>

    <div class="card-body card-body-mat-tab">
        <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
        <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

        <div class="table-container">
            <cdk-virtual-scroll-viewport #issueCDKViewPort itemSize="330" class="issue-table-viewport" minBufferPx="900"
                maxBufferPx="900">
                <div *cdkVirtualFor="let row of filteredList; let idx = index; " class="issue-table-item">
                    <div class="issue-selected-left" *ngIf="issueSelected && row.id==issueSelected.id"></div>


                    <div class="app-table issue-table grid-issue-table">
                        <div class="grid-issue-header">
                            <div class="panel-locator-container">
                                <i class="fas fa-solar-panel"></i> <span class="panel-locator">{{uiLocator(row)}}</span>
                                <div class="issue-showonmap-btn-container">
                                    <button class="btn btn-link btn-sm btn-white" type="button" matTooltip="Show on map"
                                        (click)="issueColType_click(row);"><i class="fas fa-map-marked-alt"></i> Locate on map</button>
                                </div>
                            </div>
                            
                            <div class="issue-type-container">
                                <app-ex-issuerrortype [errortypeObj]="{issueType:row.type,iconSize:'fa-3x'}" style="width: 20px;float: left;margin-right: 15px;">
                                </app-ex-issuerrortype>
                                <div class="issue-errortype-name">{{ui_errortype(row)}}</div>
                                <div class="issue-errortype-relevance">Relevance:<app-issuerelevance [issue]="row"></app-issuerelevance>
                            </div>
                            
                            </div>
                        </div>
                        <!-- <tr [id]="row.id" class="issue-main"> -->
                        <div class="grid-issue-col-image col-atop issue-col-image" (click)="openimage(row)">
                            <app-issuecanvas [issue]="row" [canvas_options]="canvas_options">
                            </app-issuecanvas>
                            <div *ngIf="showimageDate" class="image-data-container">
                                <div class="image-data">
                                    Image Date/Time: {{row.info?.date | date:'dd-MM-yyyy HH:mm:ss' }}
                                </div>
                            </div>
                        </div>
                        <div class="grid-om-col-type col-atop om-col-type">
                            <div class="col-container tab-custom tab-custom-secondary">
                                <tabset #tabgroup>
                                    <tab id="tab_measures">
                                        <ng-template tabHeading>
                                            <i class="fas fa-thermometer-half mr-1"></i> Measures
                                        </ng-template>
                                        <table class="issue-info issue-measures">
 <!--                                            <tr>
                                                <th class="title-section" colspan=2><i class="fas fa-thermometer-half"></i>
                                                    Measures</th>
                                            </tr> -->
                                            <tr>
                                                <th>Max</th>
                                                <td>{{row.info?.temperature?.max | number: '2.2-2' }} ºC</td>
                                            </tr>
                                            <tr *ngIf="showTempMeasuresMin">
                                                <th>Min</th>
                                                <td>{{row.info?.temperature?.min | number: '2.2-2' }} ºC</td>
                                            </tr>
                                            <tr>
                                                <th>Average</th>
                                                <td>{{row.info?.temperature?.mean | number: '2.2-2' }} ºC</td>
                                            </tr>
                                            <tr>
                                                <th>Thermal Gradient</th>
                                                <td>{{row.info?.temperature?.gradient | number: '2.2-2' }} ºC
                                                    <app-issuerelevance [issue]="row" [showDesc]="false">
                                                    </app-issuerelevance>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Thermal Gradient at 1000W/m2</th>
                                                <td>{{row.info?.temperature?.gradient_1kw | number: '2.2-2' }}
                                                    ºC</td>
                                            </tr>
                                        </table>
                                    </tab>
                                    <tab id="tab_om"  *ngIf="showOM && hasOMAccess">
                                        <ng-template tabHeading>
                                            <i class="fas fa-tools mr-1"></i> O&M
                                        </ng-template>
                                        <div class="opermant">
                                            <div *ngIf="!row.om">
                                                <p>There is no Operation and Maintenaince registered.</p>

                                                <button class="btn btn-outline-primary btn-sm btn-block" type="button"
                                                    matTooltip="click to edit O&M information"
                                                    (click)="showOperMant(row);"> <i
                                                        class=" far fa-edit withpointer"></i>Enter O&M</button>
                                            </div>
                                            <div *ngIf="row.om">                                            
                                            <table class="panel-table-details operationandmanintenan">
                                                <tr>
                                                    <th>
                                                        Status
                                                    </th>
                                                    <td>
                                                        <div class="check-box-icon">
                                                            <app-om-statusicon [status]="omstatus(row)">
                                                            </app-om-statusicon>
                                                        </div>
                                                        <span class="om-status-reviewedDate-header"><i class="far fa-calendar-alt"></i> Date: </span><span class="om-status-reviewedDate">{{row.om?.reviewedDate | date:'medium'}}</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        Serial Number
                                                    </th>
                                                    <td>
                                                        {{row.info.om.panel_serial}}
                 
                                                    </td>
                                                </tr>
                                                <tr class="comments">
                                                    <td colspan="2">
                                                        <div class="commentstitle">
                                                            <b>Comments</b>
                                                        </div>

                                                        <div class="comments">
                                                            {{row.om?.comments}}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <!--                                            
                                                    <tr>
                                                        <th>Raised by</th>
                                                        <td>{{row.info.om?.raisedby.name}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Start Date</th>
                                                        <td>{{row.info.om?.startDate}}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Due Date</th>
                                                        <td>{{row.info.om?.dueDate}}</td>
                                                    </tr> -->
                                            </table>
                                            <div class="om-edit-button-container">
                                                <div class="om-edit-button">
                                                    <button class="btn btn-primary btn-sm btn-rounded" type="button"
                                                        matTooltip="click to edit O&M information"
                                                        (click)="showOperMant(row);"> <i
                                                            class=" far fa-edit withpointer"></i></button>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </tab>
                                    <tab id="tab_paneltype">
                                        <ng-template tabHeading>
                                            <i class="far fa-file mr-1"></i> Panel Type
                                        </ng-template>
                                        <div *ngIf="showPanelType" class="panel-data">
<!--                                             <table class="panel-table-details panel-type">
                                                                                                     <tr>
                                                    <th class="title-section" colspan=2><i class="far fa-file"></i> Panel Type</th>
                                                </tr> 
                                                <tr>
                                                    <th>Manufacturer</th>
                                                    <td>{{row.info?.panel?.panelType?.brand}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Module Type</th>
                                                    <td>{{row.info?.panel?.panelType?.model}}</td>
                                                </tr>
                                                <tr>
                                                    <th>Power(Wp)/Type</th>
                                                    <td>{{row.info?.panel?.panelType?.electrical?.power}}/{{row.info?.panel?.panelType?.type}}
                                                    </td>
                                                </tr>
                                            </table> -->
                                            <app-panelview [panel]="row.info.panel.panelType" [showflat]="true"></app-panelview>
                                        </div>
                                    </tab>
                                </tabset>

                                <!-- <div class="view-issue-actions-container">
                                    <button class="btn btn-outline-primary btn-sm" type="button"
                                        (click)="issueColType_click(row);"><i class="fas fa-map-marked-alt"></i> Show on map</button>
                                </div> -->

                            </div>
                        </div>
                        <div class="grid-actions">
                            <div class="view-issue-actions-container">
                                <!-- <button class="btn btn-outline-primary btn-sm" type="button" matTooltip="Show on map"
                                    (click)="issueColType_click(row);"><i class="fas fa-map-marked-alt"></i></button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>

        </div>
    </div>